import type { ActionDefinition } from '../../types';
import type { ActionHandler, ActionContext } from '../../registry/ActionRegistry';

/**
 * Custom action definition
 * Allows executing arbitrary async functions
 */
export interface CustomAction extends ActionDefinition {
  type: 'custom';
  onExecute: (context: ActionContext) => void | Promise<void>;
}

/**
 * Handler for custom actions
 * Executes user-provided functions with access to adapters
 */
export class CustomActionHandler implements ActionHandler<CustomAction> {
  async execute(action: CustomAction, context: ActionContext): Promise<void> {
    if (!action.onExecute) {
      throw new Error('Custom action missing onExecute function');
    }

    await action.onExecute(context);
  }

  validate(action: CustomAction): boolean {
    return typeof action.onExecute === 'function';
  }
}
